import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class FetchService {

  constructor(private authService: AuthService) {

  }

  fetch(url: RequestInfo, options: RequestInit) {
    options.headers = new Headers(options.headers);
    options.headers.append('Authorization', this.authService.getAuthorizationHeaderValue());
    return window.fetch(url, options);
  }
}
